$('.accordion__trigger').click(function(event){
	let self = $(this);
	let accordion = self.parent();
	accordion.toggleClass('accordion__trigger--active');
	accordion.find('.accordion__content:first').stop().slideToggle();
	event.preventDefault();
});
